import { getAllData, createDocument } from "apis/customApiHandler";
import toast from "react-hot-toast";
import Model from "components/Modal";
import { useQuery, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import axios from "apis/axios";
import exportExcel from "utils/exportExcel";
import Spinner from "components/Spinner";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import { Input } from "styled";
import { Button } from "styled";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import getFormattedDate from "utils/helpers";
import Modal from "components/Modal";

const getSixMonthsAgoDate = () => {
  const today = new Date();
  const sixMonthsAgo = new Date(today);
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  const year = sixMonthsAgo.getFullYear();
  const month = String(sixMonthsAgo.getMonth() + 1).padStart(2, '0');
  const day = String(sixMonthsAgo.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const GrnStatusLastFourMonths = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({ value: "all", label: "All" });
  const [fleetMap, setFleetMap] = useState({});
  const [showBulkUploadModel, setShowBulkUploadModel] = useState(false);
  const [dateFrom, setDateFrom] = useState(getSixMonthsAgoDate());
  const [dateTo, setDateTo] = useState(getFormattedDate(new Date()));
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [downloadData, setDownloadData] =useState(null)
  const currentUser = useSelector((state) => state.user.currentUser);
  const getData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      setData([]);
      return;
    }
    setIsLoading(true);
    console.log(selectedFleets, selectedHubs, getHubOptions())
    const dt = await createDocument("/report/grnStatusLastFourMonths", {
      ...(selectedHubs?.includes("all")
        ? {
            hubCodes: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs?.length && {
            hubCodes: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...({ status: selectedStatus.value }),
    });
    // console.log(dt)
    setData(dt);
    setIsLoading(false);
  };
  const getDownloadData = async () => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setDownloading(true);
    const dt = await createDocument("/report/grnStatusLastFourMonths", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions()?.filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets?.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
          hubCodes: getHubOptions()?.filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs?.length && {
          hubCodes: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...({ status: selectedStatus.value }),
    });
    // console.log(dt)
    // setDownloadData(dt);
    setDownloading(false);
    return dt;
  };

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet.fleetCode,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub.hubCode,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet.fleetCode)
              );



              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub.hubCode,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  const getStatusOptions = useCallback(() => {
    return [
      {
        label: "All",
        value: "all",
      },
      {
        label: "Pending",
        value: "pending",
      },
      {
        label: "Accepted",
        value: "accepted",
      },
    ];
  }, []);  

  return (
    <div>
      <div className="w-full px-8 flex justify-center items-center mt-4 gap-4">
        <label className="w-full ">
          Select Fleets
          <ReactSelect  
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find((item) => item?.value === fleet)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if(allValues?.includes("clear")){
                // console.log(allValues)
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if(!selectedFleets?.includes("all") && allValues.includes("all")){
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions())
                value = value.filter(item => item.value!== "all")
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );
              
              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              // console.log({allHubs, selectedHubs})
              
              setSelectedFleets(value.map((fleet) => fleet.value));
              }
          }
            name="fleets"
            isMulti = {true}
          />
        </label>
        <label className="w-full ">
          Select Hubs
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => {
                // console.log({hub})
                return {
                  value: hub,
                  label: getHubOptions()?.find((item) => item.value === hub)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              // console.log({allValues})
              if(allValues.includes("clear")){
                setSelectedHubs([])
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                const mp = fleetMap;
                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);
                setSelectedHubs(["all"])
              } 
              else {
                // console.log({value})
                value = value.filter(value => value.value!== "all")
                // console.log({value})
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);
                // console.log({allValues})
              
                const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                const mp = {};
                selectedHubsData.map(hub=>{
                  mp[hub.fleetCode] = [];
                })

                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);                  
                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>
        <label className="w-full ">
        Select Status
        <ReactSelect
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: "transparent",
              minWidth: "100%",
              "&:hover": {
                borderColor: "rgb(34 197 94)",
              },
            }),
          }}
          className="shadow-md rounded-md py-1 mb-2"
          options={getStatusOptions()}
          value={selectedStatus}
          onChange={(selectedOption) => {
            setSelectedStatus(selectedOption || { value: "all", label: "All" });
          }}
          name="status"
          isClearable={false} // Since "All" is the default, we don't need to allow clearing
        />
      </label>
      </div>
      <div className="w-full px-8 flex mt-2 justify-start items-center gap-4">
        <label>
          Start Date{" "}
          <Input
            type="date"
            max={getFormattedDate()}
            name="dateFrom"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </label>
        <label>
          End Date{" "}
          <Input
            type="date"
            min={getFormattedDate(dateFrom)}
            name="dateTo"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </label>
        <Button
          type="button"
          className='mt-5'
          disabled={selectedFleets?.length == 0 || selectedHubs?.length === 0}
          bgPrimary
          onClick={() => getData()}
        >
          Search
        </Button>

        {downloading
          ? "Downloading..."
          : selectedHubs.length > 0 && (
              <BiCloudDownload
                className="w-10 mt-5 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                onClick={async () => {
                  // console.log(data);
                  const dt = await getDownloadData()
                  console.log('dt--',dt)
                  // setDownloading(true)
                  if (!dt || !Array.isArray(dt.data) || !dt.data.length) {
                    return;
                  }

                  let exportData = 
                    dt?.data?.map((x, idx) => ({
                      "S.N": idx + 1,
                      "Fleet Name": `${x?.fleet} (${x?.fleetCity})`,
                      "Hub Name": x?.hubName,
                      "Hub Code": x?.hubCode,
                      "Total Tyres": x?.sumOfTotaltyres,
                      "Total Tyres Accepted": x?.sumOfTyreAccepted,
                      "Total Tyres Accepted With Changes":x?.sumOfTyreRejected,
                      "Total Tyres Pending": x?.sumOfPending,
                      "Average Due Days": Math.round(x?.averageDueDays),
                    }))

                    let totalRow = {
                      "S.N": "Total",
                      "Total Tyres": dt?.totalRow?.total,
                      "Total Tyres Accepted": dt?.totalRow?.accepted,
                      "Total Tyres Accepted With Changes":
                        dt?.totalRow?.acceptedWithChanges,
                      "Total Tyres Pending": dt?.totalRow?.pending,
                      "Average Due Days": Math.round(dt?.totalRow?.averageDueDays),


                    }
                    exportData?.push(totalRow)
                    exportExcel(exportData, "GRN STATUS", true, 4)
                  
                  // setDownloading(false)
                }}
              />
            )}
        {/* <Button type="button" bgPrimary onClick={()=>setShowBulkUploadModel(true)} 
        //  disabled = {!checkPermission([permissions.manage_grns, currentUser])}
        // disabled = {(!selectedHubs.length)}
         >
            BulkUpload
          </Button> */}
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col flex items-center justify-center">S.N.</TH>
                      <TH scope="col flex items-center justify-center">Fleet Name</TH>
                      <TH scope="col flex items-center justify-center">Hub Name</TH>
                      <TH scope="col flex items-center justify-center">Hub Code</TH>
                      <TH scope="col flex items-center justify-center">Total Tyres</TH>
                      <TH scope="col flex items-center justify-center">Total Tyres Accepted </TH>
                      <TH scope="col flex items-center justify-center">Total Tyres Accepted With Changes</TH>
                      <TH scope="col flex items-center justify-center">Total Tyres Pending</TH>
                      <TH scope="col flex items-center justify-center">Average Due Days</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data &&
                      data.data?.map((d, idx) => (
                        <ViewList data={d} idx={idx} dateFrom={dateFrom} dateTo={dateTo}/>
                      ))}
                  </tbody>
                  {data?.totalRow ? <tfoot>
                    <tr className="text-gray-600 font-semibold bg-green-100">
                      <TD></TD>
                      <TD colSpan={3} className="text-left">
                        TOTAL
                      </TD>
                      
                      <TD className="text-center">
                        {data?.totalRow?.total}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.accepted}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.acceptedWithChanges}
                      </TD>
                      <TD className="text-center">
                        {data?.totalRow?.pending}
                      </TD>
                      <TD>
                        {data?.totalRow?.averageDueDays ?? "---"}
                      </TD>
                    </tr>
                  </tfoot> : <></>}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {showBulkUploadModel && (
        <BulkUpload handleClick={() => setShowBulkUploadModel(false)} />
      )}
    </div>
  );
};

export default GrnStatusLastFourMonths;

const ViewList = ({ data, idx, dateFrom, dateTo }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalQuery, setModalQuery] = useState(null)
  const [modalData, setModalData] = useState([]);
  const [fleet, setFleet] = useState("");
  const [hub, setHub] = useState("");
  const [isLoading, setIsLoading] = useState(true)

  console.log('data--',data);

  const getModalData = async (modalQueryProp) => {
    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
      toast.error("Both Start Date and End Date must be provided together.");
      return;
    }
    setShowModal(true)
    if (modalQueryProp) {
      setIsLoading(true);
      const dt = await createDocument("/report/grnStatusLastFourMonths/modalInfo", {
        hubs: modalQueryProp.hubs,
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        status: modalQueryProp.status,
      });
      // console.log(dt)
      setModalData(dt)
    }
    setIsLoading(false);
  }

  const downloadDiv = (data) => {
  
    const isClickable = parseInt(data?.data) > 0;

    return <div class="flex gap-2 items-center justify-center">
      {isClickable?
          <span
            className="hover:text-green-500 cursor-pointer"
            onClick={async () => {
              if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
                toast.error("Both Start Date and End Date must be provided together.");
                return;
              }
              setModalQuery(data)
              setFleet(data.fleet);
              setHub(data.hubName)
              await getModalData(data)
              
            }}
          >
            {data?.data}
          </span>
          : (
            <span className="cursor-not-allowed">{data?.data}</span>
          )}
          </div>
  }
  
  
  const getChalanDate = (dateString) => {
    const timestamp = parseInt(dateString.match(/\d+/)?.[0], 10);

    // Create a Date object
    const date = new Date(timestamp);

    // Format the date as dd-mm-yyyy
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    return formattedDate
  }

  const getDueDays = (dateString) => {
    
    const timestamp = parseInt(dateString.match(/\d+/)[0], 10);

    // Create a Date object
    console.log(timestamp, new Date().getTime())

    let DueDays = ( -new Date(timestamp).getTime() + new Date().getTime())/(24*60*60*1000)

    console.log('DueDays--',DueDays);

    // Format the date as dd-mm-yyyy
    return Math.round(DueDays, 0)
  }

  // const modalHandler = useCallback(
  //   (data) => {
  //     if (data) {
  //       setModalData(data);
  //       setShowModal(true);
  //     } else {
  //       setShowModal(false);
  //       setModalData([]);
  //     }
  //   },
  //   [showModal, modalData]
  // );

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={"GRN Details"}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal </h1> */}
            {isLoading ? <Spinner /> : <>
            <h1 className="w-full flex justify-end text-end px-2 my-1">
              <Button
                onClick={() => {
                  exportExcel(
                    modalData.data.map((item) => ({
                      "Req No": item.ReqNo,
                      "Challan No": item.Challan_No,
                      Challan_Date: getChalanDate(item.Challan_Date),
                      "Tyre Size": item.TyreSize,
                      "Brand": item.Brand,
                     "Due Days": !item.RecvRemark ? getDueDays(item.Challan_Date) : 0,
                     Fleet: `${modalQuery.fleet} (${item.fleetCity ?? "---"})`,
                      Hub: modalQuery.hubName,
                      "Depo Code": modalQuery.depoCode,
                      "Stencil Number": item.StencilNo,
                      "Changed Number": item.RecvStencil,
                      Action: item.RecvRemark,
                      "Accepted At": item.AcceptedAt,
                      "Accepted By": item.AcceptedBy,
                    })),
                    modalQuery?.title?.split(" ").join("_") + "_Data"

                  );

                }}
                className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
              >
                Download
              </Button>
            </h1>
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <TH scope="col">S.N.</TH>
                  <TH scope="col">Req No</TH>
                  <TH scope="col">Challan No</TH>
                  <TH scope="col">Challan Date</TH>
                  <TH scope="col">Tyre Size</TH>
                  <TH scope="col">Brand</TH>
                  <TH scope="col">Due Days</TH>
                  <TH scope="col">Fleet Name</TH>
                  <TH scope="col">Hub Name</TH>
                  <TH scope="col">Depo Code</TH>
                  <TH scope="col">Stencil Number</TH>
                  <TH scope="col">Changed Number</TH>
                  <TH scope="col">Action</TH>
                  <TH scope="col">Accepted By</TH>
                  <TH scope="col">Accepted At</TH>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {modalData?.data?.map((tyre, index) => (
                  <tr>
                    <TD>{index + 1}</TD>
                    <TD>{tyre.ReqNo}</TD>
                    <TD>{tyre.Challan_No}</TD>
                    <TD>{getChalanDate(tyre.Challan_Date)}</TD>
                    <TD>{tyre.TyreSize}</TD>
                    <TD>{tyre.Brand}</TD>
                    <TD>{!tyre.RecvRemark ? getDueDays(tyre.Challan_Date) : 0}</TD>
                    <TD>{modalQuery.fleet}({tyre.fleetCity})</TD>
                    <TD>{modalQuery.hubName}</TD>
                    <TD>{modalQuery.depoCode}</TD>
                    <TD>{tyre.StencilNo}</TD>
                    <TD>{tyre.RecvStencil}</TD>
                    <TD>{tyre.RecvRemark?.toUpperCase() ?? "---"}</TD>
                    <TD>{tyre.AcceptedBy}</TD>
                    <TD>{tyre.AcceptedAt}</TD>
                  </tr>
                ))}
              </tbody>
            </table>
            </>}
        </Modal>
      )}

      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{data?.fleet} ({data?.fleetCity})</TD>
        <TD>{data?.hubName}</TD>
        <TD>{data?.hubCode}</TD>
        <TD class= "">
          {downloadDiv({data: data.sumOfTotaltyres, fleet: data.fleet, hubName: data.hubName, depoCode: data.depoCode, title: "Total Tyres in GRN", hubs: data.hubCode, status: data?.status==="pending"?"pending":data?.status==="accepted"?"accepted":""})}
        </TD>
        <TD class= "">
        {downloadDiv({data: data.sumOfTyreAccepted, fleet: data.fleet, hubName: data.hubName, depoCode: data.depoCode, title: "Accepted Tyres in GRN", hubs: data.hubCode, status: "accept"})}

        </TD>
        <TD class= "">
        {downloadDiv({data: data.sumOfTyreRejected, fleet: data.fleet, hubName: data.hubName, depoCode: data.depoCode, title: "Tyres Accepted With Changes in GRN", hubs: data.hubCode, status: "accept with changes"})}

        </TD>
        <TD class= "">
        {downloadDiv({data: data.sumOfPending, fleet: data.fleet, hubName: data.hubName, depoCode: data.depoCode, title: "Pending Tyres in GRN", hubs: data.hubCode,status: "pending"})}
        </TD>
        <TD class="flex gap-2 items-center justify-center">{data?.averageDueDays ? parseInt(data?.averageDueDays) :  0}</TD>
      </tr>

    </Fragment>
  );
};

const BulkUpload = ({ handleClick }) => {
  const [file, setFile] = React.useState("");
  const [loading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const [correctData, setCorrectData] = React.useState(null);
  const [incorrectData, setIncorrectData] = React.useState([]);

  let downloadSampleExcelLink =
    "https://jk-fleet.s3.ap-south-1.amazonaws.com/1686825561961-sample_grn_file";

  const handleFileChange = async (e) => {
    try {
      e.preventDefault();
      let file = e.target.files[0];
      let allowedFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "text/csv",
      ];
      let regEx = new RegExp(
        allowedFileTypes.map((type) => `^.*${type}$`).join("|")
      );
      if (regEx.test(file.type)) {
        setFile(file);
      }
      if (!regEx.test(file.type)) {
        toast.error("Please Upload Only Valid Excel or Csv File");
        //clear file input
        e.target.value = "";
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async () => {
    try {
      let formData = new FormData();
      formData.append("file", file);
      setIsLoading(true);
      const response = await axios({
        method: "post",
        url: "/bulk-upload/grns",
        data: formData,
      });
      const data = await response.data;
      setIsLoading(false);
      setCorrectData(data?.uploadedData);
      setIncorrectData(data?.errors);
      toast.success("Successfully Saved");
      queryClient.invalidateQueries("/bulk-upload/tyres");
      // handleClick();
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      toast.error(
        error?.response?.data?.message
          ? error?.response?.data?.message
          : "Something went wrong"
      );
      setCorrectData(error?.response?.data?.uploadedData);
      setIncorrectData(error?.response?.data?.errors);
    }
  };

  const handleCorrectDataExport = () => {
    if (correctData?.length > 0) {
      exportExcel(correctData, "correctData");
    } else {
      toast.error("No data to export");
    }
  };

  const handleIncorrectDataExport = () => {
    if (incorrectData?.length > 0) {
      exportExcel(incorrectData, "incorrectData");
    } else {
      toast.error("No data to export");
    }
  };

  return (
    <Model
      handleClick={handleClick}
      title={"Bulk Upload"}
      className="max-w-2xl"
    >
      <div className="w-full p-8 flex flex-col justify-start items-start">
        <Button
          onClick={() => {
            // window.open(downloadSampleExcelLink, "_blank")
            const link = document.createElement("a");
            link.href = downloadSampleExcelLink;
            link.download = "grn_sample_file" + "";
            link.click();
          }}
          bgSecondary
        >
          Download Sample Excel File
        </Button>
        <Input
          type="file"
          className="shadow-sm mt-8"
          name="excelFile"
          onChange={handleFileChange}
        />
        <div className="flex gap-4">
          <Button className="mt-8" onClick={handleSubmit} bgPrimary>
            Upload
          </Button>
          <Button className="mt-8" onClick={handleClick} bgSecondary>
            Cancel
          </Button>
        </div>

        <div className="">
          {loading ? <div className="my-4"> Uploading </div> : ""}
          {correctData?.length === 0 && "No data Uploaded"}
          {correctData?.length > 0 && (
            <div>
              <div
                className="border-b-2 border-green-500 text-green-500 cursor-pointer mt-5 mb-2"
                // onClick={handleCorrectDataExport}
              >
                Uploaded Data
              </div>
              {correctData.map((dt) => {
                return <div> {dt} </div>;
              })}
            </div>
          )}
          {incorrectData?.length > 0 && (
            <div>
              <div
                className="  border-b-2 border-red-500 text-red-500 cursor-pointer mt-10 mb-2"
                // onClick={handleIncorrectDataExport}
              >
                Incorrect Data
              </div>
              {incorrectData.map((dt) => {
                return <div> {dt} </div>;
              })}
            </div>
          )}
          {/* {correctData?.length > 0 && (
            <span
              className="border-b-2 border-green-500 text-green-500 cursor-pointer"
              onClick={handleCorrectDataExport}
            >
              Download Correct Data
            </span>
          )}
          {incorrectData?.length > 0 && (
            <span
              className="  border-b-2 border-red-500 text-red-500 cursor-pointer"
              onClick={handleIncorrectDataExport}
            >
              Download Incorrect Data
            </span>
          )} */}
        </div>
      </div>
    </Model>
  );
};
